import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import FenceTuneup from "@/pages/FenceTuneup";

export const Route = createFileRoute("/_public/fence-tuneup")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Fence Tune-Up for PetPlaygrounds & CritterFence \u2014 From $299", "Bring your existing PetPlaygrounds or CritterFence install back to like-new. Tensioning, gate adjustment, splice repair, and a written report \u2014 flat $299 starting price.", "/fence-tuneup", false),
  component: FenceTuneup,
});
